import React, { useState } from 'react';
import { Button } from '@increasecard/typed-components';
import { FileIcon } from '@increasecard/icons';
import { CreateReportModal } from './CreateReportModal';
import { TFunction } from 'i18next';

interface CreateReportButtonProps extends React.HTMLAttributes<HTMLDivElement> {
  onCreateReport: () => void;
  targetText: string;
  translationFunction: TFunction;
  buttonText?: string;
  buttonType?: string;
}

export function CreateReportButton({
  onCreateReport,
  targetText,
  translationFunction,
  buttonText,
  buttonType
}: CreateReportButtonProps) {
  const [modalVisible, setModalVisible] = useState(false);
  const toggleModal = () => {
    setModalVisible((prevValue) => !prevValue);
  };
  return (
    <>
      <Button buttonType={buttonType || 'primary'} icon={<FileIcon />} onClick={toggleModal}>
        {buttonText || translationFunction('common:report:button')}
      </Button>
      <CreateReportModal
        description={translationFunction('common:report:modal:description')}
        headerText={translationFunction('common:report:modal:title', { target: targetText })}
        okLabel={translationFunction('common:report:modal:okLabel')}
        onCancel={toggleModal}
        onClose={toggleModal}
        onCreateReport={onCreateReport}
        visible={modalVisible}
      />
    </>
  );
}
